module.exports = __webpack_public_path__ + "static/media/supplychain-logo.d08c84bd.png";